module.exports = __webpack_public_path__ + "images/banners/pages_iphone/spots_left_435c1e14fce18ac4147c6fe5fd3fb51e.png";